<template>
	<div class="current-training__action-list">
		<f7-link
			v-for="(action, index) in trainingActions"
			:key="index"
			class="action-item"
			:class="[{ 'not-published': notPublished || checkPublished(action)}]"
			@click="$emit('goToAction', action.id)"
		>
			<div class="action-item__icon-wrapper">
				<svg
					viewBox="0 0 475.452 475.451"
					xml:space="preserve"
					fill="currentcolor"
					v-if="action.type.docType && action.type.docType.toLowerCase() === 'procedure'"
				>
					<path
						d="M468.083,118.385c-3.99-5.33-9.61-9.419-16.854-12.275c0.387,6.665-0.086,12.09-1.42,16.281l-85.65,281.789   c-1.526,4.948-4.859,8.897-9.992,11.848c-5.141,2.953-10.469,4.428-15.989,4.428H74.66c-22.84,0-36.542-6.652-41.112-19.985   c-1.903-5.14-1.807-9.229,0.288-12.275c2.092-2.857,5.708-4.288,10.85-4.288h248.102c17.702,0,29.93-3.285,36.688-9.852   c6.763-6.567,13.565-21.177,20.413-43.824l78.228-258.669c4.186-14.084,2.474-26.457-5.141-37.113s-18.462-15.987-32.548-15.987   H173.163c-2.474,0-7.329,0.854-14.562,2.568l0.284-0.859c-5.33-1.14-9.851-1.662-13.562-1.571   c-3.71,0.099-7.137,1.192-10.277,3.289c-3.14,2.094-5.664,4.328-7.566,6.706c-1.903,2.38-3.761,5.426-5.568,9.136   c-1.805,3.715-3.33,7.142-4.567,10.282c-1.237,3.14-2.666,6.473-4.281,9.998c-1.62,3.521-3.186,6.423-4.71,8.706   c-1.143,1.523-2.758,3.521-4.854,5.996c-2.091,2.474-3.805,4.664-5.137,6.567c-1.331,1.903-2.19,3.616-2.568,5.14   c-0.378,1.711-0.19,4.233,0.571,7.566c0.76,3.328,1.047,5.753,0.854,7.277c-0.76,7.232-3.378,16.414-7.849,27.552   c-4.471,11.136-8.52,19.18-12.135,24.126c-0.761,0.95-2.853,3.092-6.28,6.424c-3.427,3.33-5.52,6.23-6.279,8.704   c-0.762,0.951-0.81,3.617-0.144,7.994c0.666,4.38,0.907,7.423,0.715,9.136c-0.765,6.473-3.14,15.037-7.139,25.697   c-3.999,10.657-7.994,19.414-11.993,26.265c-0.569,1.141-2.185,3.328-4.853,6.567c-2.662,3.237-4.283,5.902-4.853,7.99   c-0.38,1.523-0.33,4.188,0.144,7.994c0.473,3.806,0.426,6.66-0.144,8.562c-1.521,7.228-4.377,15.94-8.565,26.125   c-4.187,10.178-8.47,18.896-12.851,26.121c-1.138,1.906-2.712,4.145-4.708,6.711c-1.999,2.566-3.568,4.805-4.711,6.707   c-1.141,1.903-1.903,3.901-2.284,5.996c-0.19,1.143,0.098,2.998,0.859,5.571c0.76,2.566,1.047,4.612,0.854,6.14   c-0.192,2.662-0.57,6.187-1.141,10.567c-0.572,4.373-0.859,6.939-0.859,7.699c-4.187,11.424-3.999,23.511,0.572,36.269   c5.33,14.838,14.797,27.36,28.406,37.541c13.61,10.185,27.74,15.27,42.398,15.27h263.521c12.367,0,24.026-4.141,34.971-12.416   c10.944-8.281,18.227-18.507,21.837-30.696l78.511-258.662C477.412,141.51,475.701,129.234,468.083,118.385z M164.31,118.956   l5.997-18.274c0.76-2.474,2.329-4.615,4.709-6.423c2.38-1.805,4.808-2.712,7.282-2.712h173.589c2.663,0,4.565,0.903,5.708,2.712   c1.14,1.809,1.335,3.949,0.575,6.423l-6.002,18.274c-0.764,2.475-2.327,4.611-4.713,6.424c-2.382,1.805-4.805,2.708-7.278,2.708   H170.593c-2.666,0-4.568-0.9-5.711-2.708C163.74,123.567,163.55,121.431,164.31,118.956z M140.615,192.045l5.996-18.271   c0.76-2.474,2.331-4.615,4.709-6.423c2.38-1.809,4.805-2.712,7.282-2.712h173.583c2.666,0,4.572,0.9,5.712,2.712   c1.14,1.809,1.331,3.949,0.568,6.423l-5.996,18.271c-0.759,2.474-2.33,4.617-4.708,6.423c-2.383,1.809-4.805,2.712-7.283,2.712   H146.895c-2.664,0-4.567-0.9-5.708-2.712C140.043,196.662,139.854,194.519,140.615,192.045z"
					/>
				</svg>
				<svg
					viewBox="0 0 488.3 488.3"
					xml:space="preserve"
					fill="currentcolor"
					v-else-if="action.type.docType && action.type.docType.toLowerCase() === 'training'"
				>
					<path
						d="M488.3,142.5v203.1c0,15.7-17,25.5-30.6,17.7l-84.6-48.8v13.9c0,41.8-33.9,75.7-75.7,75.7H75.7C33.9,404.1,0,370.2,0,328.4
																					V159.9c0-41.8,33.9-75.7,75.7-75.7h221.8c41.8,0,75.7,33.9,75.7,75.7v13.9l84.6-48.8C471.3,117,488.3,126.9,488.3,142.5z"
					/>
				</svg>
				<svg
					viewBox="0 0 500.002 500.002"
					xml:space="preserve"
					fill="currentcolor"
          v-else-if="action.type.docType && action.type.docType.toLowerCase() === 'agreement'"
				>
					<path
						d="M493.146,23.427L476.574,6.851c-9.14-9.132-24.012-9.136-33.144,0L35.846,414.443c-0.032,0.032-0.048,0.068-0.08,0.1
													c-0.216,0.22-0.4,0.468-0.584,0.716c-0.132,0.172-0.276,0.336-0.392,0.52c-0.132,0.196-0.228,0.416-0.332,0.624
													c-0.136,0.26-0.276,0.516-0.38,0.784c-0.016,0.044-0.04,0.076-0.056,0.124l-21.28,58.9L2.29,486.666
													c-3.052,3.052-3.052,8,0,11.048c1.528,1.528,3.524,2.288,5.524,2.288s4.004-0.76,5.524-2.288l10.452-10.456l58.9-21.276
													c0.048-0.016,0.084-0.04,0.124-0.056c0.268-0.108,0.524-0.244,0.784-0.38c0.212-0.108,0.424-0.2,0.624-0.332
													c0.184-0.116,0.352-0.26,0.524-0.4c0.248-0.18,0.492-0.364,0.716-0.58c0.032-0.032,0.068-0.052,0.096-0.084L462.406,87.306
													l5.636,5.64l-137.84,137.852c-3.056,3.052-3.056,7.996,0,11.048c1.524,1.524,3.524,2.288,5.524,2.288
													c1.996,0,3.996-0.764,5.524-2.288L484.626,98.47c1.464-1.464,2.288-3.452,2.288-5.524c0-2.072-0.824-4.06-2.288-5.524
													l-11.172-11.168l19.692-19.692C502.286,47.435,502.286,32.567,493.146,23.427z"
					/>
				</svg>

        <svg fill="currentcolor" viewBox="-64 0 512 512" xmlns="http://www.w3.org/2000/svg"
             v-else-if="action.type && action.type.id === 9"
        >
          <path
              d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"/>
        </svg>

        <svg fill="currentcolor" viewBox="-64 0 512 512" xmlns="http://www.w3.org/2000/svg"
             v-else-if="action.type && action.type.id === 11"
        >
          <path
              d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"/>
        </svg>

        <i class="fa fa-list" aria-hidden="true" style="font-size: 50px" v-else-if="action.audit"></i>

        <ItemDoneMark v-if="action.done"/>
			</div>
			<div class="action-name">
        <div class="name"> {{ getRightActionName(action.action) }} </div>
        <div
            class="publisher"
            v-if="!action.done && !action.publish && action.type.id !== 9 && action.type.id !== 11">
          {{
            `Waiting for ${publisher || currentTraining.role.title} to publish`
          }}
        </div>
			</div>
		</f7-link>
	</div>
</template>
<script>
	import ItemDoneMark from "@/components/ItemDoneMark.vue";
  import {mapGetters} from "vuex";

	export default {
		props: {
			notPublished: Boolean,
			trainingActions: Array,
			publisher: String,
		},
		methods: {
			getRightActionName(actionName) {
				if (!this.notPublished) {
					return actionName;
				}
				return actionName.replace("Write your", "Review");
			},
      checkPublished(action) {
        return (action.type.id !== 9 && action.type.id !== 11 && !action.publish) || (action.type.id === 9 && action.type.id === 11)
      },
		},
    created() {
      this.trainingActions.sort((a,b) => {
        if (a.priority > b.priority) return 1
        return a.publish ? -1 : 1
      })
    },
    components: { ItemDoneMark },
    computed: {
      ...mapGetters("trainings", ["currentTraining"]),
    },
  };
</script>
<style lang="scss"></style>
